<template>
  <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
    <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
      <a-card>
        <div slot="title"><a-icon type="file-search" />&nbsp;Search</div>
        <ul class="m-list-wrapper">
          <li>
            <a-input-search v-model="search" placeholder="Quick Search" />
          </li>
          <li>
            <a-collapse :activeKey="getScreen ? 0 : 1">
              <a-collapse-panel key="1">
                <span slot="header">Search More...</span>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Transaction Date</label>
                  <a-range-picker :placeholder="['Start Date', 'End Date']" v-model="transactionDt"
                    :format="getDefaultDateFormat" allowClear />
                </div>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Status</label>
                  <a-select placeholder="Ex: Approved ... " v-model="status" class="width-full" initialValue="delivered"
                    allowClear>
                    <a-select-option value="delivered">Delivered</a-select-option>
                    <a-select-option value="approved">Approved</a-select-option>
                    <a-select-option value="on process">On Process</a-select-option>
                    <a-select-option value="revised">Revised</a-select-option>
                    <a-select-option value="rejected">Rejected</a-select-option>
                  </a-select>
                </div>
              </a-collapse-panel>
            </a-collapse>
          </li>
        </ul>
      </a-card>
    </a-col>
    <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
      <DataList :loading="loading" title="PD Activity Reports List" :manifestLink="getManifestLink" :dataList="searching"
        :disabledCreateEditLink="true" :isMonitoring="true" />
    </a-col>
  </a-row>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import moment from "moment";
import _ from "lodash";

export default {
  name: "listLapKegPd",
  props: ["prnMenu"],
  data() {
    return {
      loading: true,
      dataList: [],
      search: "",
      status: undefined,
      transactionDt: [],
    };
  },
  mounted() {
    this.fetchData();
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
    ]),
    searching() {
      var self = this;
      let outputData = this.dataList;

      if (this.search) {
        outputData = _.filter(
          outputData,
          (obj) =>
            obj.searchQ.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
        );
      }

      if (this.status) {
        outputData = _.filter(
          outputData,
          (obj) =>
            obj.status && obj.status.toLowerCase().indexOf(this.status) >= 0
        );
      }

      if (self.transactionDt.length > 0) {
        let startDt = moment(self.transactionDt[0]).format(
          this.getStandartFormatDate
        );
        let endDt = moment(self.transactionDt[1]).format(
          this.getStandartFormatDate
        );
        outputData = _.filter(
          outputData,
          (obj) => obj.tgl_buat >= startDt && obj.tgl_buat <= endDt
        );
      }

      return outputData;
    },
    getManifestLink() {
      if (localStorage.getItem("nvpn") === "/hrd") {
        return "SpclLapKegPdManifestHrd";
      } else if (localStorage.getItem("nvpn") === "/pimpro") {
        return "SpclLapKegPdManifestPimpro";
      } else if (localStorage.getItem("nvpn") === "/atasanLangsung") {
        return "SpclLapKegPdManifestAL";
      } else if (localStorage.getItem("nvpn") === "/direktur") {
        return "SpclLapKegPdManifestDir";
      } else if (localStorage.getItem("nvpn") === "/keuangan") {
        return "SpclLapKegPdManifestKeu";
      } else if (localStorage.getItem("nvpn") === "/sitejakarta") {
        return "SpclLapKegPdManifestJkt";
      } else if (localStorage.getItem("nvpn") === "/akuntansiKeuangan") {
        return "SpclLapKegPdManifestAcc";
      } else if (localStorage.getItem("nvpn") === "/vpf") {
        return "SpclLapKegPdManifestVpf";
      } else if (localStorage.getItem("nvpn") === "/FinancialControl") {
        return "SpclLapKegPdManifestFin";
      } else if (localStorage.getItem("nvpn") === "/marketing") {
        return "SpclLapKegPdManifestMar";
      } else {
        return "SpclKasKecilManifest_";
      }
    },
  },
  methods: {
    moment,
    fetchData() {
      axios({
        method: "get",
        url: this.$serviceUrl + "monitoring/lap_kegiatan_pds",
        params: {
          tlc: this.getAuth.username,
          id: localStorage.getItem("nvky"),
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          _.forEach(response.data.data, (data) => {
            this.dataList.push({
              searchQ:
                data.no_pdlk +
                " " +
                this.moment(data.tgl_laporan)
                  .format(this.getDefaultDateFormat)
                  .toString()
                  .toLowerCase() +
                " " +
                data.tlc_pembuat +
                " " +
                data.deskripsi,
              title: data.no_pdlk,
              timeline: JSON.parse(data.status_app),
              unread: data.unread == "1" ? true : false,
              subdesc: [
                [
                  {
                    label: "Tanggal Pelaporan",
                    value: this.moment(data.tgl_buat).format(
                      this.getDefaultDateFormat
                    ),
                  },
                ],
                [
                  {
                    label: "Tanggal Dinas",
                    value:
                      this.moment(data.tgl_mulai).format(
                        this.getDefaultDateFormat
                      ) +
                      " - " +
                      moment(data.tgl_selesai).format(
                        this.getDefaultDateFormat
                      ),
                  },
                ],
                { deskripsi: data.deskripsi },
              ],
              tgl_buat: data.tgl_buat,
              status: data.status,
              id: data.id_manifest,
              cancelStatus: data.cancel_sts,
            });
          });
          this.loading = false;
        })
        .catch((err) => {
          if (!err.response) {
            this.displayMessage("error-connection-refused");
          }
        });
    },
  },
};
</script>

<style lang="less">
.ant-list-item {
  &-action {
    background-color: whitesmoke;
    padding: 5px 0;
  }
}
</style>
